import { Flex, theme } from 'antd'
import { LoadingCard } from './LoadingCard.tsx'

const { useToken } = theme

export const LoadingComponent = () => {
    const { token } = useToken()

    return (<>
        <Flex
            justify='center'
            align='center'
            style={{
                width: '100vw',
                height: '100vh',
                background: token.colorBgLayout
            }}
        >
            <LoadingCard
                title='Please wait, MoneyFlow is on the case...'
                alt='App is loading...'
            />
        </Flex>
    </>)
}
